<template>
    <div>
        <div class="leaderBox" v-if="showOrhide1">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt1">
            <img src="../../../assets/images/xqgl1.png" class="steps step4" v-if="status1==1">
            <img src="../../../assets/images/xqgl2.png" class="steps step5" v-if="status1==2">
            <img src="../../../assets/images/xqgl3.png" class="steps step6" v-if="status1==3">
            <img src="../../../assets/images/xqgl4.png" class="steps step7" v-if="status1==4">
            <div class="stepbtn" @click="nextStep1(status1)">
                {{status1==1?"下一步":status1==2?"下一步":status1==3?"下一步":status1==4?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked1">下次不再提示</el-checkbox>
            </div>
        </div>
<!--        <breadcrumb :routerList="[{to:'/xuqiu/resourceList',title:'资源需求管理'},{title:'资源需求列表'}]"/>-->
      <Breadtabsheader/>
        <div style="margin:20px">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="场景">
							    <el-select v-model="q.jobGroup" :v="q.jobGroup"
							               placeholder="请选择" :clearable="true"
							               @change="okJobPoint">
							        <el-option v-for="(item) in JobGroup"
							                   :key="item.id"
							                   :label="item.jobGroup"
							                   :value="item.jobGroup"
							        >
							        </el-option>
							    </el-select>
							</el-form-item>
							<el-form-item label="节点">
							    <el-select v-model="q.jobPoint" :v="q.jobPoint"
							               placeholder="请选择" :clearable="true" :disabled="!q.jobGroup">
							        <el-option v-for="(item,index) in JobPoint"
							                   :key="index"
							                   :label="item"
							                   :value="item"
							        >
							        </el-option>
							    </el-select>
							</el-form-item>
							<el-form-item label="提报日期" class="timeselect" style="width: 50%;">
								<el-date-picker
									placeholder="请选择"
									v-model="q.startCdate"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
								 <span class="w-time-to">至</span>
								<el-date-picker
									placeholder="请选择"
									v-model="q.endCdate"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="区域">
										<brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :clearable="true"
												  style="width:100%"/>
									</el-form-item>
									<el-form-item label="提报人">
										<el-input v-model="q.cuname" placeholder="请输入名称"></el-input>
									</el-form-item>
									<el-form-item label="客户名称">
										<el-input v-model="q.euNameLike" placeholder="请输入客户名称"></el-input>
									</el-form-item>

								</div>
							</div>
                        </el-collapse-transition>
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
							</el-button>
							<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
							           @click="createdemand">新增需求
							    <!-- v-auth="'xuqiu_xinzengzyxuqiu'"-->
							</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-row ljjtablexuqius">
                <div class="h-rowIn" style="width: 57%;">
                    <div style="height: 9.3rem;overflow: hidden;background-color: white;position: relative;">
                        <div class="h-rowBox" style="border-bottom: none;box-shadow: none;">
                            <div class="h-rowTitle h-pdl0">
                                <div class="h-el-tab">
                                    <ul>
                                        <li :class="{'h-active':index==indx}" v-for="(item,index) in list" :key="index"
                                            @click="tabIndex(index)"><a>{{item}}</a></li>
                                    </ul>
                                </div>
                            </div>
                            <el-table
                                    class="ljjtablesdata"
                                    :span-method="objectSpanMethod"
                                    :data="tableData"
                                    :border="true"
                                    style="width: 100%"
                                    @row-click="checkDetail">
                                <el-table-column
                                        prop="cuname"
                                        label="提报人"
                                        width="100"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="areaCode"
                                        label="区域"
                                        width="75"
                                >
                                    <template slot-scope="scope">
                                        {{scope.row.areaCode | dictname('YLRegion')}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="jobGroup"
                                        label="场景"
                                        width="100"
                                        :show-overflow-tooltip="true"
                                >
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">{{scope.row.jobGroup}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="jobPoint"
                                        label="链群节点"
                                        width="100"
                                        :show-overflow-tooltip="true"
                                >
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">{{scope.row.jobGroupPoint}}-{{scope.row.jobPoint}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="content"
                                        :show-overflow-tooltip="true"
                                        min-width="150"
                                        label="描述">
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">{{scope.row.content}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="cdate"
                                        width="120"
                                        :show-overflow-tooltip="true"
                                        label="创建日期">
                                    <template slot-scope="scope">
                                        <div style="text-align: left;">{{scope.row.cdate?scope.row.cdate.substring(0,10):''}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="状态"
										width="100"
                                >
                                    <template slot-scope="scope">
                                        <div  v-if="scope.row.isLoop == 1" style="color: #2eaf68;border-radius: 0.2rem;padding: 0.05rem;border: 1px solid #2eaf68;">
                                            已闭环
                                        </div>
                                        <div  v-if="scope.row.isLoop ==0 && scope.row.inNumber==0 && scope.row.isOverdue ==0 && scope.row.isTrip==0" style="color: #258efe;border-radius: 0.2rem;padding: 0.05rem;border: 1px solid #258efe;">
                                            未回复
                                        </div>
                                        <div  v-if="scope.row.isLoop ==0 && scope.row.inNumber==1" style="color: #BF3EFF;border-radius: 0.2rem;padding: 0.05rem;border: 1px solid #BF3EFF;">
                                            未闭环
                                        </div>

                                        <div v-if="scope.row.isLoop ==0 && scope.row.inNumber==0 && scope.row.isOverdue ==1 && scope.row.isTrip==0" style="color: #f2bd2e;border-radius: 0.2rem;padding: 0.05rem;border: 1px solid #f2bd2e;">
                                            逾期
                                        </div>
                                        <div v-if="scope.row.isLoop ==0 && scope.row.inNumber==0 && scope.row.isOverdue ==1 && scope.row.isTrip==1" style="color: #FF0000;border-radius: 0.2rem;padding: 0.05rem;border: 1px solid #FF0000;">
                                            跳闸
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="fenyes" style="margin-top: 0.3rem">
                                <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
                            </div>
                            <div v-if="tableData.length<5"
                                 style="display:flex;justify-content:center;padding-top: 30px;align-items: center;">
                                <img src="../../../assets/images/mylittle.png" alt="" style="width: 75%;">
                            </div>
                            <div class="h-rowBoxB h-rowBoxBtnOut"
                                 style="margin: 0;padding: 0.11rem 0.26rem;display: flex;align-items: center;height: 67px;position: absolute;bottom: 0;left: 0;width: 100%;border: 1px solid #d7e0f1;">
                                <!-- <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>-->
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                           @click="exportExcel">批量导出
                                    <!--v-auth="'xuqiu_zypiliangdaochu'"-->
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-rowIn" style="width: 43%;">
                    <div style="height: 9.3rem;overflow-y: auto;background-color: white;padding: 0;position: relative;">
                        <div class="h-rowBox">
                            <div class="h-rowTitle" v-show="ifchart">
                                <div class="h-disTable">
                                    <div class="h-tableCell">
                                        <h1>需求统计</h1>
                                    </div>
                                </div>
                            </div>
                            <div class="h-rowCon" style="padding-bottom: 0">
                                <div v-show="ifchart">
                                    <div class="h-gaugePieChart" id="h_gaugePie"
                                         style="width:100%;height:3.7rem;"></div>

                                    <div class="totals" v-if="this.indx ==0">全部 {{chartPer.all}}</div>
                                    <div class="totals" v-if="this.indx ==1">已闭环 {{chartPer.ybh}}</div>
                                    <div class="totals" v-if="this.indx ==2">未闭环 {{chartPer.wbh}}</div>
                                    <div class="totals" v-if="this.indx ==3">未回复 {{chartPer.whf}}</div>
                                    <div class="totals" v-if="this.indx ==4">逾期 {{chartPer.yq}}</div>
                                    <div class="totals" v-if="this.indx ==5">跳闸 {{chartPer.tz}}</div>
                                </div>
                                <!--右下侧详情展示-->
                                <div class="h-runningDetail" v-show=detailShow>
                                    <div class="h-rdTitle">
                                        <h1 style="font-weight: normal;margin-bottom:10px;">需求详情</h1>
                                    </div>
                                    <div class="h-rdTitle">
                                        <h1>{{qdetail.demand?qdetail.demand.euName:""}}</h1>
                                        <label v-if="qdetail.isLoop == 1">已闭环</label>
                                        <label v-if="qdetail.isLoop ==0 && qdetail.inNumber==0 && qdetail.isOverdue ==0 && qdetail.isTrip==0">未回复</label>
                                        <label v-if="qdetail.isLoop ==0 && qdetail.inNumber==1">未闭环</label>
                                        <label v-if="qdetail.isLoop ==0 && qdetail.inNumber==0 && qdetail.isOverdue ==1 && qdetail.isTrip==0">逾期</label>
                                        <label v-if="qdetail.isLoop ==0 && qdetail.inNumber==0 && qdetail.isOverdue ==1 && qdetail.isTrip==1">跳闸</label>
                                    </div>
                                    <div class="h-rdForm" style="overflow-y: auto;height: 7rem;">
                                        <div class="h-rdFormWrap" style="width:100%;text-align: left;height: auto;">
                                            <p class="h-grayFont">痛点</p>
                                            <p v-if="qdetail.demand" :title="qdetail.demand.pain">{{qdetail.demand.pain}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" style="width:100%;text-align: left;height: auto;">
                                            <p class="h-grayFont">需求描述</p>
                                            <p v-if="qdetail.demand" :title="qdetail.demand.content">{{qdetail.demand.content}}</p>
                                        </div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont">客户类型</p>
                                            <p>{{qdetail.demand?qdetail.demand.euType:""}}</p>
                                        </div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont">区域</p>
                                            <p>{{qdetail.demand?qdetail.demand.areaCode:""}}</p>
                                        </div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont">部门/科室</p>
                                            <p>{{qdetail.demand?qdetail.demand.department:""}}</p>
                                        </div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont">联系人</p>
                                            <p>{{qdetail.demand?qdetail.demand.contactuserName:""}}</p>
                                        </div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont">联系方式</p>
                                            <p>{{qdetail.demand?qdetail.demand.telephone:""}}</p>
                                        </div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont">需求截至日期</p>
                                            <p>{{qdetail.endDate}}</p>
                                        </div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont">提报人</p>
                                            <p>{{qdetail.cuname}}</p>
                                        </div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont">链群</p>
                                            <p>{{qdetail.jobGroup}}</p>
                                        </div>
                                        <div class="h-rdFormWrap">
                                            <p class="h-grayFont">链群节点</p>
                                            <p>{{qdetail.jobGroupPoint}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" style="margin-bottom: 0.05rem;">
                                            <p class="h-grayFont">节点</p>
                                            <p>{{qdetail.jobPoint}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" style="margin-bottom: 0.05rem;">
                                            <p class="h-grayFont">指定答复人</p>
                                            <p>{{qdetail.jobUsername}}</p>
                                        </div>
                                        <div class="h-rdFormWrap" style="margin-bottom: 0.05rem;">
                                            <p class="h-grayFont">答复人工号</p>
                                            <p>{{qdetail.jobUsercode}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="h-rowBoxB h-rowBoxBtnOut" v-show="detailShow"
                                 style="position: absolute;bottom: 0;left: 0;width: 100%;margin: 0;padding: 0.11rem 0.16rem;height: 67px;border: 1px solid #d7e0f1;">
                                <el-button class="el-button h-btn h-formBtn h-bgblueQ el-button--default"
                                           @click="xuqiuDetail(qdetail)">详情
                                </el-button>
                            </div>
                        </div>
                        <div v-auth="lianqunShow" v-show="_user.usertype!=1&&lianqunShow">
                            <el-table
                                    :data="lianData"
                                    :border="true"
                                    style="width: 100%;margin-bottom: 0.1rem;">
                                <el-table-column
                                        prop="jobGroup"
                                        label="场景/链群节点"
                                        :show-overflow-tooltip="true">
                                    <template scope="scope">
                                        <div @click="lianDataPage(scope.row)">
                                            <span v-if="scope.row.jobGroup">{{scope.row.jobGroup}}</span>
                                            <span v-if="scope.row.jobPoint">{{scope.row.jobGroupPoint}}-{{scope.row.jobPoint}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="chartAll"
                                        label="全部"
                                        width="65">
										<template scope="scope">
											<div style="text-align: right;">
												{{scope.row.chartAll}}
											</div>
										</template>
                                </el-table-column>
                                <el-table-column
                                        prop="chartYBH"
                                        label="已闭环"
                                        width="75">
										<template scope="scope">
											<div style="text-align: right;">
												{{scope.row.chartYBH}}
											</div>
										</template>
                                </el-table-column>
                                <el-table-column
                                        prop="chartWBH"
                                        label="未闭环"
                                        width="75">
										<template scope="scope">
											<div style="text-align: right;">
												{{scope.row.chartWBH}}
											</div>
										</template>
                                </el-table-column>
                                <el-table-column
                                        prop="chartWHF"
                                        label="未回复"
                                        width="75">
										<template scope="scope">
											<div style="text-align: right;">
												{{scope.row.chartWHF}}
											</div>
										</template>
                                </el-table-column>
                                <el-table-column
                                        prop="chartYQ"
                                        label="逾期"
                                        width="65">
										<template scope="scope">
											<div style="text-align: right;">
												{{scope.row.chartYQ}}
											</div>
										</template>
                                </el-table-column>
                                <el-table-column
                                        prop="chartTZ"
                                        label="跳闸"
                                        width="65">
										<template scope="scope">
											<div style="text-align: right;">
												{{scope.row.chartTZ}}
											</div>
										</template>
                                </el-table-column>
                            </el-table>
                            <div class="fenyes">
                                <paginationminNosize :page="l" @query="lianDataPage" style="padding-top: 0.1rem"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <demandadd :visible.sync="imgflag2" v-if="imgflag2" @imgfalse2="imgflag2=false"/>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                lianData:[],
                //链群
                JobGroup: [],
                JobPoint:[],
                showOrhide1: false,
                status1: 1,
                checked1: true,
                toshow1: "Lmanagement3",
                imgflag2: false,
                //caifile:false,
                //xuqiu:false,
                //ziyuan:false,
                //当前登陆人的权限列表
                rolelist: [],
                //导入Excel
                uploaddownexcelflag: false,
                caiuploaddownexcelflag: false,
                ziuploaddownexcelflag: false,
                timeValue: null,
                shoor: false,
                //全选
                /* checkedCities: [],
                 cities: this.cityOptions,
                 cityOptions: [],
                 checkAll: false,*/
                multipleSelection: [],
                lianqunShow:true,
                detailShow: false,
                xuqiudex: 0,
                dialogFormVisible1: false,
                dialogFormVisible2: false,
                formLabelAlign2: {},
                val: [],
                n: {},
                //切换
                indx: 0,
                list: ['全部', '已闭环', '未闭环','未回复','逾期','跳闸'],
                q: {
                    startCdate: '',
                    endCdate: '',
                    euNameLike: null,
                    jobGroup:null,
                    jobPoint:null,
                    areaCode:null,
                    cuname:null,
                    isLoop:null,
                    isTrip:null,
                    isOverdue:null,
                    inNumber:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                l:{
                    jobGroupPoint:null,
                    jobGroup:null,
                    pageSize: 6,
                    pageNo: 1,
                    total: 0,
                },
                tablelist: [],
                tableName: {},
                tableData: [],
                LevelName: [],
                qdetail: {
                    id: null,
                    demandType: null,
                    customer: {
                        areaCode: null,
                    }
                },
                //表单
                f: {
                    demandType: null,
                    rdId: null,
                    userCode: null,
                    resDescribe: null,
                    content: null,
                    cid: null,
                    remark: null,
                    cucode: null,
                    cuname: null,
                    cdate: null,
                    lucode: null,
                    ldate: null,
                    delflag: null,
                    endDate: null,
                    euCode: null,
                    euName: null,
                    detail: [
                        {
                            depName: null,
                        }
                    ],
                    customer: [],
                },
                //弹出框
                dialogFormVisible: false,
                chartPer: {
                    all: 0,
                    wbh:0,
                    whf:0,
                    yq:0,
                    ybh:0,
                    tz:0
                },
                options: {},
                ifchart: true,
                CGList: [],
                DDList: [],
                ZYList: [],
            }
        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        activated(){
            this.query();
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].rdId === this.tableData[index - 1].rdId) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (column.label == '提报人' || column.label == '区域'){
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
            //右下角链群表格
            lianDataPage(v){
                if(v){
                    this.l.jobGroup = v.jobGroup;
                    this.l.pageSize = 6;
                    this.l.pageNo = 1;
                    this.l.total = 0;
                }
                ss.UserDemand.lianDataPage(this.l).then(rd => {
                    this.l.total = rd.total;
                    this.lianData = rd.records;
                });
            },
            //节点筛选可用
            okJobPoint(){
                if(this.q.jobGroup!=null){
                    ss.UserDemand.selectJobPoint(this.q.jobGroup).then(rd => {
                        this.JobPoint = rd;
                    });
                }else{
                    this.JobPoint=null;
                    this.q.jobPoint = null;
                }
            },
            //部门列表
            selectJobGroup() {
                ss.UserDemand.selectJobGroup().then(rd => {
                    this.JobGroup = rd;
                });
            },
            showzhezhao() {
                ss.salesList.toshow(this.toshow1).then(rd => {
                    if (rd == false) {
                        this.showOrhide1 = false;
                    } else {
                        this.showOrhide1 = true;
                    }
                })
            },
            timeSelect() {
                if (this.timeValue == null || this.timeValue == '') {
                    this.q.startCdate = null;
                    this.q.endCdate = null;
                } else {
                    this.q.startCdate = this.timeValue[0];
                    console.log("1111111",this.q.startCdate)
                    this.q.endCdate = this.timeValue[1];
                    console.log("1111111",this.q.endCdate)
                }
            },
            daoru() {
                this.dialogFormVisible2 = true;
            },
            //重置检索项
            resetData() {
                this.q.jobGroup = null;
                this.q.jobPoint = null;
                this.q.euNameLike = null;
                this.q.areaCode = null;
                this.timeValue = null;
                this.q.startCdate = null;
                this.q.endCdate = null;
            },
            //检索
            handleFilter(query) {
                this.query();
                this.chartP();
            },
            //全部/已转化/为转化标签
            tabIndex(i) {
                this.indx = i;
                if (this.indx == 0) {
                    this.q.isLoop =null ;
                    this.q.inNumber = null;
                    this.q.isOverdue =null ;
                    this.q.isTrip = null;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环'
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',

                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',

                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',

                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',

                        }
                    ];
                } else if (this.indx == 1) {
                    this.q.inNumber = null;
                    this.q.isOverdue =null ;
                    this.q.isTrip = null;
                    this.q.isLoop = 1;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环'
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',
                            selected:true,
                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',
                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',
                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',
                        }
                    ];
                } else if (this.indx == 2) {
                    this.q.isOverdue =null ;
                    this.q.isTrip = null;
                    this.q.isLoop =0;
                    this.q.inNumber =1 ;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环',
                            selected:true,
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',
                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',
                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',
                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',
                        }
                    ];
                }else if (this.indx == 3) {
                    this.q.isLoop =0 ;
                    this.q.inNumber = 0;
                    this.q.isOverdue =0 ;
                    this.q.isTrip = 0;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环'
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',
                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',
                            selected:true,
                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',
                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',

                        }
                    ];
                }else if (this.indx == 4) {
                    this.q.isLoop =0 ;
                    this.q.inNumber= 0;
                    this.q.isOverdue =1 ;
                    this.q.isTrip= 0;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环'
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',

                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',

                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',
                            selected:true,
                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',

                        }
                    ];
                }else if (this.indx == 5) {
                    this.q.isLoop =0 ;
                    this.q.inNumber= 0;
                    this.q.isOverdue =1 ;
                    this.q.isTrip= 1;
                    this.query();
                    this.options.series.data = [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环'
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',

                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',

                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',

                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',
                            selected:true,
                        }
                    ];
                }
                this.getPieChartnow();
                this.ifchart = true;
                this.detailShow = false;
                this.lianqunShow = true;
            },
            //表格
            query() {
                ss.UserDemand.showZYXQPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    /*this.cityOptions = [];
                    for (let i = 0; i < 10; i++) {
                        this.cityOptions.push(i + 1);
                    }*/
                    this.getSpanArr();
                });
            },
            //右侧图表数据展示
            chartP() {
                ss.UserDemand.resourceChart(this.q).then(rd => {
                    this.chartPer.all = rd.chartNum.chartAll;
                    this.chartPer.wbh = rd.chartNum.chartWBH;
                    this.chartPer.whf = rd.chartNum.chartWHF;
                    this.chartPer.ybh = rd.chartNum.chartYBH;
                    this.chartPer.yq = rd.chartNum.chartYQ;
                    this.chartPer.tz = rd.chartNum.chartTZ;
                    this.getPieChart();
                })
            },
            getPieChartnow() {
                let h_gaugePie = this.$echarts.init(document.getElementById('h_gaugePie'));
                let placeHolderStyle = {
                    normal: {
                        color: 'rgba(0,0,0,0)',
                        label: {show: false},
                        labelLine: {show: false}
                    },
                    emphasis: {
                        color: 'rgba(0,0,0,0)'
                    }
                };

                h_gaugePie.setOption(this.options);
            },
            getPieChart() {
                let h_gaugePie = this.$echarts.init(document.getElementById('h_gaugePie'));
                let placeHolderStyle = {
                    normal: {
                        color: 'rgba(0,0,0,0)',
                        label: {show: false},
                        labelLine: {show: false}
                    },
                    emphasis: {
                        color: 'rgba(0,0,0,0)'
                    }
                };
                let option = {
                    tooltip: {
                        show: true,
                    },
                    legend: {
                        show: false
                    },
                    grid: {
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0
                    },
                    color: ['#BF3EFF','#2eaf68', '#258efe', '#f2bd2e','#FF0000'],
                    series: {
                        type: 'pie',
                        radius: "70%",
                        center: ['50%', '50%'],
                        labelLine: {
                            show: true,
                            length: 10,
                        },
                        label: {
                            show: true,
                            formatter: '{b}{c}',
                        },
                        data: [
                            {
                                value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                                name: '未闭环'
                            },
                            {
                                value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                                name: '已闭环',

                            },
                            {
                                value: this.chartPer.whf ? this.chartPer.whf : 0,
                                name: '未回复',

                            },
                            {
                                value: this.chartPer.yq ? this.chartPer.yq : 0,
                                name: '逾期',

                            },
                            {
                                value: this.chartPer.tz ? this.chartPer.tz : 0,
                                name: '跳闸',

                            }
                        ]
                    }
                }
                h_gaugePie.setOption(option);
            },
            //右下侧详细数据展示
            checkDetail(value) {
                this.detailShow = true;
                this.lianqunShow = false;
                this.ifchart = false;
                ss.UserDemand.resourceDetail(value.id).then(rd => {
                    this.qdetail = rd;
                    this.qdetail.demand.euType = this.$getDictName("userCareType", rd.demand.euType);
                    this.qdetail.demand.areaCode = this.$getDictName("YLRegion", rd.demand.areaCode);
                });
            },
            //新增需求
            createdemand() {
                this.$router.push('/xuqiu/createResources');
            },
            xuqiuEdit(value) {
                this.$router.push({
                    path: "/xuqiu/createResources",
                    query: {id: value.id, demandType: value.demandType}
                });
            },
            //点击详情跳转
            xuqiuDetail(value) {
                this.$router.push({path: "/xuqiu/resources", query: {id: value.id}});
            },
            //明细导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/xuqiu/userResDemandDept/downloadExcel", this.q, "post");
            },
            closeIt1() {
                this.showOrhide1 = false;
                if (this.checked1) {
                    ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                        console.log(rd)
                        this.showOrhide1 = false;
                    })
                } else {
                    ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                        console.log(rd)
                        this.showOrhide1 = false;
                    })
                }
            },

            nextStep1(i) {
                if (this.status1 == 1) {
                    this.status1 = 2;
                } else if (this.status1 == 2) {
                    this.status1 = 3;
                } else if (this.status1 == 3) {
                    this.status1 = 4;
                } else if (this.status1 == 4) {
                    if (this.checked1) {
                        ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                            console.log(rd)
                            this.showOrhide1 = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow1, this.checked1).then(rd => {
                            console.log(rd)
                            this.showOrhide1 = false;
                        })
                    }
                }

            },
        },
        created() {
            this.showzhezhao();
            this.selectJobGroup();
            this.query();
            this.chartP();
            if(this._user.usertype==1){
                this.lianqunShow = false;
            }else{
                this.lianDataPage();
            }
        },
        mounted() {
            this.chartP();
            this.query();
            this.options = {
                tooltip: {
                    show: true,
                },
                legend: {
                    show: false
                },
                grid: {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                },
                /*color: ['#2eaf68', '#258efe', '#f2bd2e'],*/
                color: ['#BF3EFF','#2eaf68', '#258efe', '#f2bd2e','#FF0000'],
                series: {

                    type: 'pie',

                    selectedOffset: 10,
                    radius: "70%",
                    center: ['50%', '50%'],
                    labelLine: {
                        show: true,
                        length: 10,
                    },
                    label: {
                        show: true,
                        formatter: '{b}{c}',
                    },
                    data: [
                        {
                            value: this.chartPer.wbh ? this.chartPer.wbh : 0,
                            name: '未闭环'
                        },
                        {
                            value: this.chartPer.ybh ? this.chartPer.ybh : 0,
                            name: '已闭环',
                        },
                        {
                            value: this.chartPer.whf ? this.chartPer.whf : 0,
                            name: '未回复',
                        },
                        {
                            value: this.chartPer.yq ? this.chartPer.yq : 0,
                            name: '逾期',
                        },
                        {
                            value: this.chartPer.tz ? this.chartPer.tz : 0,
                            name: '跳闸',
                        }
                    ]
                }
            }

        },
    }
</script>

<style scoped>
    .cuname {
        font-size: 0.16rem;
        color: #323232;
    }

    .selectbbbb {
        display: flex;
        align-items: center;
        border-bottom: 2px solid #f9f9f9;
    }

    .selectbbbb:hover {
        background: #f5fcff;
    }

    .h-gaugePieLegend .h-gpLegendLi i {
        margin-top: -12px;
    }

    .totals {
        text-align: center;
        font-size: 0.22rem;
        color: #282828;
        margin-bottom: 20px;
    }


    .h-formLines {
        padding: 30px 48px;
    }

    .xuqiuBoxList {
        width: 100%;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
    }

    .xuqiuBoxList .xuqiulist {
        width: 200px;
        height: 62px;
        border-radius: 4px;
        background: #fff;
        border: 1px solid #959595;
        text-align: center;
        line-height: 62px;
        color: #989898;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
    }

    .xuqiuBoxList .xuqiulist:first-child {
        margin-left: 0
    }

    .xuqiuBoxList .xuqiulist.active {
        background: #238cfd;
        border: 1px solid #238cfd;
        color: #fff;
    }

    .xuqiutext {
        color: #bcbcbc;
        font-size: 14px;
        margin-bottom: 14px;
    }

    /* .piliang1 {
        font-size: 18px;
        color: #303030;
        margin-top: 10px;
        margin-left: 10px;
    }

    .piliang2 {
        font-size: 16px;
        color: #919191;
        margin-top: 10px;
        margin-left: 10px;
    } */

    /* .piliangBox {
        display: flex;
        margin-top: 20px;
        align-items: center;
        margin-left: 10px;
    }

    .piliangBox .imgs {
        font-size: 16px;
        color: #4b4b4b;
        margin-left: 20px;
    }

    .piliangBox .imgs:first-child {
        margin-left: 0
    } */
</style>
<style>
    .selectcheckbox .el-checkbox:hover {
        background: 0
    }

    .selectcheckbox .el-checkbox {
        margin-bottom: 5px
    }

    .selectcheckbox .el-checkbox__label {
        display: none
    }

    .h-dialogForm .h-elformWrap-3 .el-form-item__label:first-child {
        width: 23%;
    }

    .h-dialogForm .h-elformWrap-3 .el-form-item__content {
        width: 70%;
    }

    .el-form-item__content .secondX {
        position: absolute;
        top: 0;
        left: -89px;
        color: red;
        font-size: 0.2rem;
    }

    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }

    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }

    .fenyes .el-pagination .el-pagination__sizes {
        display: none;
    }

    /* .h-formBorder .timeselect .el-form-item__content {
        line-height: 0.2rem;
    } */

    .h-formBorder .timeselect .el-date-editor .el-range-separator {
        width: 8%;
        line-height: 28px;
    }

    .h-formBorder .timeselect .el-input__inner {
        padding-right: 0.1rem;
    }

    .timeselect .el-date-editor.el-input__inner {
        width: 3.5rem;
    }

    .ljjtablesdata.el-table tbody td:first-child{
        border-left: 0;
    }
    .ljjtablesdata.el-table tbody td:first-child{
        border-right: 1px solid #EBEEF5;
    }
    .ljjtablesdata.el-table tbody td:nth-child(2){
        border-right: 1px solid #EBEEF5;
    }
    .ljjtablesdata.el-table tbody td{
        border-right: 0;
    }
    .ljjtablesdata.el-table thead{
        color: #323232;
    }
    .ljjtablesdata.el-table thead tr{
        background-color: rgba(0,0,0,0);
    }
    .ljjtablesdata.el-table thead th{
        background: none;
    }
    .ljjtablesdata.el-table .warning-row {
        background: #f5fcff;
    }
    .ljjtablesdata.el-table .zfenleis{
        padding: 0.05rem;
        background: #fce0b7;
        color: #d99a4b;
        margin-right: 0.05rem;
    }
    .ljjtablesdata.el-table .zfenleis:nth-child(2){
        background: #d1e4ff;
        color: #006ccf;
    }
	.ljjtablexuqius .el-table tbody td .cell{
		padding: 0.1rem;
	}
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step4 {
            top: 0.8rem;
            left: 0rem;
            width: 6.6rem;
            height: 15rem;
        }

        .step5 {
            top: 2.2rem;
            right: 1.35rem;
            width: 4.7rem;
            height: 1rem;
        }

        .step6 {
            top: 2.28rem;
            left: 2.6rem;
            width: 9.2rem;
            height: 12rem;
        }

        .step7 {
            top: 3.45rem;
            right: 0.2rem;
            width: 6.9rem;
            height: 12rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>
